import React, { ReactElement } from 'react';
import { Col, Container, Button, Navbar, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export default function MyFooter(): ReactElement {
    return (
        <Navbar bg="light" expand="lg">
            <Container fluid className="container-vitrine">
                <Row className="align-items-center flex-grow-1">
                    <Col className="flex-grow-1 py-2">
                        <LinkContainer to="/">
                            <Navbar.Brand>
                                <img
                                    style={{ mixBlendMode: 'multiply' }}
                                    alt="solution-animation"
                                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/logo_solanim.jpg"
                                />
                            </Navbar.Brand>
                        </LinkContainer>
                    </Col>
                    <Col className="flex-grow-0">
                        <Button href="https://www.solutionanimation.com/nous-joindre/" className="text-nowrap">
                            Contactez-nous
                        </Button>
                    </Col>
                    <Col className="flex-grow-0">
                        <a
                            href="https://www.facebook.com/SolutionAnimationQC"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/6/6c/Facebook_Logo_2023.png" // Replace with path to Facebook logo
                                alt="Facebook"
                                width="32"
                                height="32"
                            />
                        </a>
                    </Col>

                    <Col className="flex-grow-1 py-2">
                        <div className="d-flex">
                            <div className="ml-auto text-center">
                                Isaac Barbe <br />
                                514-942-5155
                                <br />
                                Fondateur – Solution Animation
                                <br />
                                isaacbarbe@solutionanimation.com <br />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Navbar>
    );
}
